<template>
  <div class="popup_wrap">
    <div class="popup_box">
      <slot class="img" name="icon"></slot>
      <slot name="content"></slot>
      <slot name="button_wrap"></slot>
    </div>
  </div>
</template>
<script>
export default {
  name: 'popup',
  props: {
    icon: {
      type: String,
      default: 'waraing'
    }
  }
}
</script>
<style scoped lang="scss">
@import "@/assets/base.scss";

.popup_wrap {
  position: fixed;
  left: 0;
  top: 0;
  width: 100vw;
  height: 100vh;
  z-index: 999;
  background: rgba(0, 0, 0, 0.6);

  .popup_box {
    position: absolute;
    width: 75vw;
    height: fit-content;
    left: 0;
    right: 0;
    top: 0;
    bottom: 0;
    margin: auto;
    padding: 4.6875vw 4vw 4vw;
    box-shadow: 0 0.5vh 1vh rgba(19, 21, 23, 0.3);
    border-radius: 4vh;
    background: $white;
    text-align: center;
    .icon {
      padding-bottom: 3.5vh;
      img {
        width: 10vh;
        height: 10vh;
      }
    }
    .content {
      padding-bottom: 5vh;
      font-size: 36px; // IE11 fallback
      font-size: unquote("min(2.8125vw, 36px)");
      font-weight: 700;
      color: $black;
      line-height: 1.5;
      span.light_blue {
        font-weight: bold;
        color: $light_blue;
      }
    }
    .button_wrap {
      display: flex;
      justify-content: space-around;
      .button {
        flex-grow: 1;
        flex-basis: 0;
        padding: 3.5vh 0;
        font-size: 32px; // IE11 fallback
        font-size: unquote("min(2.5vw, 32px)");
        color: $gray_800;
        border-radius: 20px;
        box-sizing: border-box;
        background: #E6E8EB;
        font-weight: 700;
        &.light_blue {
          margin-left: 1.25vw;
          color: $white;
          border-color: $light_blue;
          background: $light_blue;
        }
      }
    }
  }
}
</style>
